import React, {Fragment, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,} from 'react-bootstrap';
import axios from 'axios';
import Recepisse from '../../components/RecepisseDepot/index'
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { InputOption } from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import Update from '../Update/index';
import { useNavigate } from 'react-router-dom';
import './recrutement.css';
import Env from '../../hooks/Env';
import anaqsup from '../../img/anaq-sup.png'
import ept from '../../img/ept.jpg'
import logouam from '../../img/logo_UAM1.png'
import ism from '../../img/ism.png'
import nmt from "../../img/nmt.png"
import { Image } from 'react-bootstrap';
const renderTooltip = (props) => (
    <Tooltip id="button-tooltip"  {...props}>
      Ajouter un nouveau fichier
    </Tooltip>
  );
  const IconForFile = (props) => {
    return (
        <>
        <OverlayTrigger
            placement="right"
            delay={{ show: 100, hide: 400 }}
            overlay={renderTooltip}
            >
            <FontAwesomeIcon onClick={() => {props.toggleInputVisibility(props.name)}} icon={faFile} className='btn btn-primary mr-2' />
        </OverlayTrigger>
        </>
    )
  }
const Depot = ({props}) => {
    const API_URL = Env().API_URL ;
    console.log(API_URL)
    const [InputVisible, SetInputVisible] = useState({
        'communication5':false,
        'justificatif':false,
        'diplome':false,
        'publication2':false,
        'publication3':false,
        'publication4':false,
        'publication5':false,
        'publication6':false,
        'publication7':false,
        'publication8':false,
        'publication9':false,
        // 'publication10':false,
        'communication2':false,
        'communication3':false,
        'communication4':false,
        'justificatif2':false,
        'justificatif1':false,
        'justificatif3':false,
        'justificatif4':false,
        'justificatif5':false,
        'justificatif6':false,
        'justificatif7':false,
        'justificatif8':false,
        'diplome2':false,
        'diplome3':false,
        'diplome4':false,
        'diplome5':false,
        'diplome6':false,
    })
    const toggleInputVisibility = (state) => {
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
    }
    
    const removeFile = (fieldName,state) => {
        console.log("Au moment ",selectedFiles.publication7)
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
        // Créez une copie de l'état actuel
        const updatedFiles = { ...selectedFiles };
      
        // Supprimez l'élément spécifique
        updatedFiles[fieldName] = null;
      
        // Mettez à jour l'état avec la nouvelle copie
        setSelectedFiles(updatedFiles);
        console.log("Aprés mise à jour ",selectedFiles.publication7)
      };
    const [dataForm, setDataForm] = useState('');
    const [nationalities, setNationalities] = useState([]);
    const [step, setStep] = useState(1);
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const [message, setMessage] = useState('')
    const [typefille, setTypeFile] = useState(false)
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "cv":true,
        "copie_carte_id" : true,
        "demande" : true,
        "lettre_motivation" : true,
        "copie_diplome" : true,
        "recommandation1" : true,
        "recommandation2" : true,
        "resume_these" : true,
        "publication_scientifique" : true,
        "attestation_travail" : true,
        "justificatif1" : true,
        "justificatif2" : true,
        "justificatif3" : true,
        "justificatif4" : true,
        "justificatif5" : true,
        "justificatif6" : true,
        "communication" : true,
        "diplome2" : true,
        "diplome3" : true,
        "diplome4" : true,
        "diplome5" : true,
        "diplome6" : true,
        "justificatif7" : true,
        "justificatif8" : true,
        "communication2" : true,
        "communication3" : true,
        "communication4" : true,
        "communication5" : true,
        "publication2" : true,
        "publication3" : true,
        "publication4" : true,
        "publication5" : true,
        "publication6" : true,
        "publication7" : true,
        "publication8" : true,
        "publication9" : true,
        // "publication10" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv":false,
        "copie_carte_id" : false,
        "demande" : false,
        "lettre_motivation" : false,
        "copie_diplome" : false,
        "recommandation1" : false,
        "recommandation2" : false,
        "resume_these" : false,
        "publication_scientifique" : false,
        "attestation_travail" : false,
        "justificatif1" : false,
        "justificatif2" : false,
        "justificatif3" : false,
        "justificatif4" : false,
        "justificatif5" : false,
        "justificatif6" : false,
        "communication" : false,
        "diplome2" : false,
        "diplome3" : false,
        "diplome4" : false,
        "diplome5" : false,
        "diplome6" : false,
        "justificatif7" : false,
        "justificatif8" : false,
        "communication2" : false,
        "communication3" : false,
        "communication4" : false,
        "communication5" : false,
        "publication2" : false,
        "publication3" : false,
        "publication4" : false,
        "publication5" : false,
        "publication6" : false,
        "publication7" : false,
        "publication8" : false,
        "publication9" : false,
        // "publication10" : false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        // console.log(selectedFiles.publication7)
        var file = event.target.files[0];
            const elements = document.getElementsByName(key)
            if (file?.size < maxFileSize){
                setTypeFile(false)
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var i = 0; i < elements.length; i++) {
                    var element1 = elements[i];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element1.style.border = ""; // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }
            } else {
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                for (var j = 0; j < elements.length; j++) {
                    var element = elements[j];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element.style.border = "2px solid #BC0C0C";
                    element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }

            }
    };
    // const navigate = useNavigate('')
      useEffect(() => {
        // navigate('/')  //pour forcer la redirection au cas ou 
        // const fetchNationalities = async () => {
        //     try {
        //       const response = await fetch('https://restcountries.com/v3.1/all');
        //       if (!response.ok) {
        //         throw new Error('Unable to fetch nationalities.');
        //       }
        //       const data = await response.json();
        //       let nationalities = data.map(country => country.name.common);
        //       nationalities = nationalities.sort()
        //       setNationalities(nationalities)
        //       return nationalities;
        //     } catch (error) {
        //       console.error('Error fetching nationalities:', error);
        //       return [];
        //     }
        //   };
        //   fetchNationalities()
      },[dataForm.type_poste]) 
      // Exemple d'utilisation
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(value,name)
    }
    const handleNextStep = () => {
        if (step === 1) {
           if (!dataForm.email || !dataForm.civilite || !dataForm.prenom|| !dataForm.nom || !dataForm.date_naissance || !dataForm.lieu_naissance || !dataForm.telephone || !dataForm.address) {
                setErrors(true)
           } else if (!valid.isValidPhoneNumber) {
            setMessageAlerte('Format du numéro incorrect')
        }
           
           else {
                setErrors(false)
                setStep(step + 1)
           }
            
        } else if (step === 2) {
            setStep(step + 1);
            // console.log(dataForm.type_poste,dataForm.poste,dataForm.ecole_postulee,dataForm.annee_experience,dataForm.pays,dataForm.diplome)
            if (dataForm.type_poste === 'PER') {
                if (dataForm.type_poste && dataForm.poste && dataForm.ecole_postulee && dataForm.annee_experience && dataForm.pays && dataForm.diplome) {
                //    setErrors(false);
                    // setStep(step + 1);
                   } else {
                        // setErrors(true);
                }   
            } else {
                if (dataForm.poste==="Executive Coaching") {
                    console.log(dataForm.poste,dataForm.annee_experience)
                    dataForm.annee_experience = 1;
                }
                if (dataForm.type_poste && dataForm.poste && dataForm.annee_experience && dataForm.pays && dataForm.diplome) {
                  //  setErrors(false);
                  //  setStep(step + 1);
                } else {
                  //  setErrors(true);
                }
            }
            
        }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            const nameFiles = ["cv","copie_carte_id","demande","lettre_motivation","copie_diplome","communication","recommandation1","recommandation2","resume_these",
            "publication_scientifique","attestation_travail","justificatif1","justificatif2","justificatif3","justificatif4","justificatif5","justificatif6",
            "diplome2","diplome3","diplome4","diplome5","diplome6","justificatif7","justificatif8","communication2","communication3","communication4",
            "communication5","publication2","publication3","publication4","publication5","publication6","publication7","publication8","publication9"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
            for (let key in dataForm) {
                // console.log(dataForm[key])
                if (dataForm.hasOwnProperty(key)) {
                      if( dataForm[key] !== null) {
                        // if (key === 'pays') {
                        //     if (dataForm['type_poste'] === 'PATS') {
                        //         if (dataForm['pays'] !== 'senegal') {
                        //             dataForm['pays'] = 'SENEGAL'
                        //         }
                        //     }
                        // }
                        formData.append(key ,dataForm[key])
                      }
              }
            }
            var showALerte = nameFiles.some(field => selectedFiles[field] === false);
        //  for (let pair of formData.entries()) {
        //         console.log(pair[0] + ':' + pair[1]);
        //       }
            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Incorrect')
                setShow(true);
            
            }
            else if (showALerte) {
                 setShow(true);
                //  setOk(false)
            }
            else if (typefille) {
                alert('format de fichier incoorecte !')
            }
            else {
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${API_URL}/recrutement/`,
                    formData,
                    {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            // console.log(response)
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    // console.log(response.data.detail)
                    setDeppotSuccess2(true)
                } else {
                    // console.log(response)
                    setSubmitted(false);
                    // console.log('Files uploaded successfully');
                    // console.log('Recepissé :' + response?.data?.data)
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                    // console.log("message : " + response.data.message);
                    // console.log(data);
                }
            } else {
                console.error('Error uploading files');
                console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
       console.error('Error', error);
    }
};
    const calculateProgress = () => {
        // Calculez le pourcentage de progression en fonction du numéro d'étape
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
  return (
    <>
    <Alert show={show} handleClose={handleClose} />
    {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
    {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
    {update ? <Update /> : null}
    <div>
        <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
            <Button variant='success' className=' p-2' onClick={handleUpdate}>Modifier son dossier </Button> 
            {/* <Button variant='success' className=' p-1 '>Supprimer  son dossier </Button>*/}
        </div>
    </div>
      <div className='container mb-2 ' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            <div className="progress mb-1" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div>
            </div>
        <div id='nameModule' className=''>
            <div className='row text-center align-items-center justify-content-center my-3' >
                <Image className='col-md-2 col-sm-6 mb-3' src={nmt} height={80} width={80} alt="anaq-sup" />
                <Image className='col-md-2 col-sm-6 mb-3' src={anaqsup} height={80} width={80} alt="anaq-sup" />
                <Image className='col-md-2 col-sm-6 mb-3' src={ept} height={80} width={80} alt="ept" />
                <Image className='col-md-2 col-sm-6 mb-3' src={logouam} height={80} width={80} alt="wave" />
                <Image className='col-md-2 col-sm-6 mb-3' src={ism} height={80} width={80} alt="wave" />
            </div>
            <div>
                <p> {step===1 ? 'Informations personnelles' : '' }</p>
                    <p> {step===2 ? 'Informations professionels' : '' }</p>
                    <p> {step===3 ? 'Dossiers de Candidature' : '' }</p>
            </div>
        </div>
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div>
                {step === 1 && (
                    <div id="step1" className='mb-3'>
                        <Input type='email' focus={true} value={dataForm.email || ''} label="Adresse mail" name='email' onChange={handleChange} />
                        <Form.Group>
                            <div className='d-inline'>
                                <Form.Check
                                inline
                                        type="radio"
                                        label="Monsieur"
                                        value='Monsieur'
                                        required
                                        checked = {dataForm.civilite === 'Monsieur'}
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='d-inline'>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Madame"
                                        value='Madame'
                                        checked = {dataForm.civilite === 'Madame'}
                                        required
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                            </Form.Group>
                            <div className='row' id='test'>
                            <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                            <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                            </div>
                            <div className='row'>
                                <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} />
                                {/* {older ? <span style={{color:'red'}}>Le concours  est ouvert aux bacheliers âgés de 22 ans au maximum en 2023.. </span>: null} */}
                                <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Lieu de naissance" name='lieu_naissance' onChange={handleChange} />
                            </div> 
                            <InputT type='number' value={dataForm.telephone || ''} label="Téléphone"  name='telephone' onChange={handleChange} />
                            {!valid.isValidPhoneNumber ? <span style={{color:'red'}}>{messageAlerte} </span>: null}
                            <Input type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
                    </div>
                )}
                {step === 2 && (
                <div className='mb-3'>
                <Form.Group id='serie'>
                    <Form.Label className='fw-medium'>Preciser le type de recrutement <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='type_poste' required value={dataForm.type_poste} onChange={handleChange}>
                        <option key='' value="" >--- Selectionner ---</option>
                        {/* <option key='pats' value="PATS">Etudiant</option> */}
                        {/* <option key='pats' value="PATS">Formation CEPEC</option> */}
                        <option key='pere' value="PER">Formation en Assurance Qualité Interne rojet National Multiplication Trainings (NMT)
</option>
                        {/* <option style={{'cursor':'pointer'}} key='etu' value="ETU">Etudiant</option> */}
                    </Form.Select>
                </Form.Group>
                {dataForm.type_poste === 'PATS' ?
                     <Form.Group id=''>
                     <Form.Label className='fw-medium'>Modules Certifiants<span style={{color:'red'}}>*</span></Form.Label>
                     <Form.Select name='ecole_postulee' required value={dataForm.ecole_postulee} onChange={handleChange}>
                                 <option value="" >--- Selectionner ---</option>
                                 <option  >Productivité augmentée avec le No-code et l'IA générative</option>
                                 <option >Stratégies de communication et marketing digital</option>
                                 <option >Dynamique d'intelligence collective et facilitation</option>
                                 <option >Synergies collaboratives et culture du travail en équipe</option>
                                 <option >Entreprendre avec impact : de l'idée à l'action</option>
                                 <option >Leadership et coaching</option>                                 

                     </Form.Select>
                     {/* <Form.Label className='fw-medium'>Etablissement<span style={{color:'red'}}>*</span></Form.Label>
                     <Form.Select name='ecole_postulee' required value={dataForm.ecole_postulee} onChange={handleChange}>
                                 <option value="" >--- Selectionner ---</option>
                                 <option  value="SEG">UFR Sciences économiques et de gestion (SEG) </option>
                                 <option value="STA">UFR Sciences et technologies Avancées (STA)</option>
                                 <option value="TECNA">UFR Technologies de la communication numérique et de l'audiovisuelle (TECNA)</option>
                                 <option value="polytech">POLYTECH DIAMNIADIO</option>
                     </Form.Select> */}
                 </Form.Group>
                : null} 
                <Form.Group id='ecole'>
                    <Form.Label className='fw-medium'>{dataForm.type_poste === 'PATS' ? 'Type de Formation' : 'Situation Professionnelle'}  <span style={{color:'red'}}>*</span> </Form.Label>
                    <Form.Select name='poste' required value={dataForm.poste}  className='mb-2'  onChange={handleChange}>
                        <option value="" >--- Selectionner ---</option>
                        {dataForm.type_poste ? 
                        <>
                            {(dataForm.type_poste !== 'PATS' ) ?
                            <>
                                    <InputOption label="PER" />
                                    <InputOption label="PATS" />
                                {dataForm.ecole_postulee === 'STA' ? 
                                        <Fragment>
                                            <InputOption label="Enseignant Chercheur en Génie Civil " />
                                            {/* <InputOption label="Enseignant Chercheur en Ecologie Marine" /> */}
                                        </Fragment> 
                                : null}
                                {dataForm.ecole_postulee === 'TECNA' ? 
                                        <Fragment>
                                            <InputOption label="Enseignant Chercheur en Littérature Française du XVI ème Siècle" />
                                            <InputOption label="Enseignant Chercheur en Sociolinguistique" />
                                            <InputOption label="Enseignant Chercheur en Communication Digitale" />
                                            <InputOption label="Enseignant Chercheur en Sciences de gestion" />
                                        </Fragment> 
                                : null}
                                {dataForm.ecole_postulee === 'polytech' ? 
                                        <Fragment>
                                            <InputOption label="Enseignant Chercheur en Gestion" />
                                            <InputOption label="Enseignant Chercheur en Economie" />
                                            <InputOption label="Enseignant Chercheur en Informatique" />
                                            <InputOption label="Enseignant Chercheur en Electronique et Télécommunications" />
                                            <InputOption label="Enseignant Chercheur en Géosciences" />
                                        </Fragment> 
                                : null}
                            </>
                            : 
                            <>
                                {/* <InputOption value="CSA" label="Chef des services administratifs (CSA)" /> */}
                                <InputOption value="Formation TECNA" label="Formation Certifiante en ligne (UFR TECNA)" />
                            </>
                        }
                        </> 
                            : null}
                    </Form.Select>     
                </Form.Group>
                <Form.Group>
                    
                    {dataForm.type_poste === 'PER' ? <Input type='fonction' required={false} value={dataForm.fonction || ''} label="fonction" placeholder='Directeur'  name='fonction' onChange={handleChange} /> : null }
                   {dataForm.type_poste === 'PER' ?  <InputT type='text' value={dataForm.etablissement || ''} label="Etablissement D'origine"  name='etablissement' placeholder='Université Amadou Mahtar MBOW (UAM )' onChange={handleChange} /> : null }
                    {/* <Form.Label className='fw-medium'>Diplome le plus élevé<span style={{color:'red'}}>*</span></Form.Label> */}
                {dataForm.type_poste === 'PATS' ? <>  <Form.Label className='fw-medium'> Situation professionnelle<span style={{color:'red'}}>*</span></Form.Label> 
                    <Form.Select name='pays' required value={dataForm.pays} onChange={handleChange}>
                        <option value="">--- Selectionner ---</option>
                        {dataForm.type_poste ? 
                        <>
                            {dataForm.type_poste === 'PATS' ?
                            <>
                                <option>Doctorat</option>
                                 <option>Professionnel</option>
                                {/* <option>Doctorat d'état</option>
                                <option>Nouvelle thèse</option> */}
                                <option>Thèse unique</option>
                                <option>PHD ou equivalent</option>
                                <option>Doctorat 3eme Cycle</option>
                                <option>Master</option>
                                <option>Ingénieur</option>
                            </>
                            :
                            <>
                                {/* <option>Master</option> */}
                                <option>Doctorant</option>
                                <option>Professionnel</option>
                                {/* <option>Licence 3</option> */}
                                {/* <option>Master 1</option> */}
                                {/* <option>Master 2</option> */}
                            </>
                        }
                        </>
                        : null }
                    </Form.Select>
                  </>  : null }
                </Form.Group>
                        <Form.Group className="" id="">
                            <Form.Label className='fw-medium'>Diplome Obtenu<span style={{color:'red'}}>*</span></Form.Label>
                            <Form.Select name='diplome' required value={dataForm.diplome} onChange={handleChange}>
                            <option key="" value="">--- Selectionner ---</option>
                                {dataForm.type_poste? 
                                <>
                                    <option>Doctorat</option>
                                    <option  key="M" >Master</option>
                                    <option  key="I" >Ingenieur</option>
                                    <option>Licence</option>
                                    <option>BTS</option>
                                    <option>DUEL</option>
                                    <option>DEUG</option>
                                    <option>Master 2</option>
                                </> :
                                <>
                                {/* {nationalities.map((nationnality,index) =>
                                    <>
                                    <option key={index}>{nationnality}</option>
                                    </>
                                    )} */}
                                </>
                                 }
                    </Form.Select>
                    
                </Form.Group>
                
                {dataForm.type_poste === "PATS" ? 
                <>
                    <Form.Group id=''>
                        <Input className="mt-2" type='text' label="Année Obtention Diplome" placeholder='Ex 2025' name='publication10' value={dataForm.publication10 || ''} onChange={handleChange} />
                    <Form.Label className='fw-medium'>Secteur d'activité <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Control type='text'placeholder='Ex Sante ...' name='annee_experience' required value={dataForm.annee_experience || ''} onChange={handleChange} />
                    {/* <Form.Select name='annee_experience' required value={dataForm.annee_experience} onChange={handleChange}>
                        <option value="" >--- Selectionner ---</option>
                        <option> 5 </option>
                        <option>plus de 5 </option>
                        <option>plus de 10 </option>
                    </Form.Select> */}
                </Form.Group>
                </> : null} 
                    {/* <Input type='text' label="Nationalité " defaulValue="Sénégalaise"  /> */}
                </div>
                )}
                {/* terminaison de step 2 */}
                {/* step 3 */}
                {step === 3 && (
                <div className='mb-3'>
                    <InputF required={true} className="rounded-left mb-2" label= {dataForm.type_poste === "PER" ? "Lettre de Soutien" : "lettre de motivation"} message={<span style={{color:'red'}}>*</span>} type='file' name='resume_these' onChange={(e) => handleFileChange(e,"resume_these")} />
                    {!selectedFiles["resume_these"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null} 
                     <InputF required={true} className="rounded-left mb-2" label="CV" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                            {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            <InputF required={true} className="rounded-left mb-2" label="Projet" message={<span style={{color:'red'}}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e,"demande")} />
                            {!selectedFiles["demande"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    {dataForm.type_poste === 'PATS' 
                    ? 
                        <>
                            <InputF required={true} id="copie_carte" className="rounded-left mb-2" label="Dernier diplôme obtenu" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
                            {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            <InputF required={true} className="rounded-left mb-2" label="CV" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                            {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            <InputF required={false} className="rounded-left mb-2" label="Dernière attestation de travail" message={<span style={{color:'red'}}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e,"demande")} />
                            {!selectedFiles["demande"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        </> 
                    : 
                        <div>
                            <Input required={true} className="rounded-left mb-2 col-md-6 col-sm-12" label="Nom du projet" type='text' name='nom_projet' value={dataForm.nom_projet || ''} onChange={handleChange} />
                            <Input required={true} className="rounded-left mb-2 " label="Décrivez les objectifs du projet que vous souhaitez déployer dans votre établissement" type='textarea' name='objectif_projet' value={dataForm.objectif_projet || ''} onChange={handleChange} />
                            <Input required={true} className="rounded-left mb-2 " label="Quel est le contexte du projet et comment sera-t-il mis en place au sein de votre établissement ?" type='textarea' name='contexte_projet' value={dataForm.contexte_projet || ''} onChange={handleChange} />
                            <Form.Label className='fw-medium'>Avez-vous assez d'expertise pour mettre en œuvre le projet<span style={{color:'red'}}>*</span></Form.Label>
                            <Form.Select required value = {dataForm.expertise_projet || ''} name='expertise_projet' onChange={handleChange} className='mb-2'>
                                <InputOption value="Oui" label="Oui" />
                                <InputOption value="Non" label="Non" />
                            </Form.Select>
                            <Input required={true} className="rounded-left mb-2 " label="Envisagez-vous une coopération avec d’autres départements ou l’intervention de spécialistes externes ?" type='textarea' name='partenariat_projet' value={dataForm.partenariat_projet || ''} onChange={handleChange} />
                            <Input required={true} className="rounded-left mb-2 " label="Quels acteurs sont impliqués dans le projet et quelles sont leurs responsabilités ?" type='textarea' name='acteur_responsabilite_projet' value={dataForm.acteur_responsabilite_projet || ''} onChange={handleChange} />
                            <Input required={true} className="rounded-left mb-2 " label="Quelles sont vos attentes relatives au projet concernant la formation ?" type='textarea' name='attente_projet' value={dataForm.attente_projet || ''} onChange={handleChange} />
                        </div>
                    }
                    
                    {/* <InputF required={true} className="rounded-left mb-2" label="Lettre de Motivation" message={<span style={{color:'red'}}>*</span>} type='file' name='lettre_motivation' onChange={(e) => handleFileChange(e,"lettre_motivation")} />
                    {!selectedFiles["lettre_motivation"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
                    <InputF required={true} className="rounded-left mb-2" label="Copies légalisées des attestations et certificats de travail" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_diplome' onChange={(e) => handleFileChange(e,"copie_diplome")} />
                    {!selectedFiles["copie_diplome"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
                    <InputF required={true} className="rounded-left mb-2" label="Copies légalisées des diplomes" message={<span style={{color:'red'}}>*</span>} type='file' name='diplome2' onChange={(e) => handleFileChange(e,"diplome2")} />
                    <span className='text-muted'>Au plus 3 </span> <br />
                    {!selectedFiles["diplome2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null} */}
                    {/* {gestionfichier["diplome2"] && gestionfichier["copie_diplome"]?  
                            <>
                            {!InputVisible.diplome3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='diplome3' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome3' onChange={(e) => handleFileChange(e,"diplome3")} />
                                    {!selectedFiles["diplome3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["diplome3"] ?  
                            <>
                            {!InputVisible.diplome4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='diplome4' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome4' onChange={(e) => handleFileChange(e,"diplome4")} />
                                    {!selectedFiles["diplome4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        } */}
                        {/* {gestionfichier["diplome4"] ?  
                            <>
                            {!InputVisible.diplome5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='diplome5' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome5' onChange={(e) => handleFileChange(e,"diplome5")} />
                                    {!selectedFiles["diplome5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["diplome5"] ?  
                            <>
                            {!InputVisible.diplome6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='diplome6' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome6' onChange={(e) => handleFileChange(e,"diplome6")} />
                                    {!selectedFiles["diplome6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        } */}
                    {dataForm.type_poste === 'PERs' ? 
                    <>
                        <InputF   className="rounded-left mb-2" label="Lettre de recommendation 1"  type='file' name='recommandation1' onChange={(e) => handleFileChange(e,"recommandation1")} />
                        {!selectedFiles["recommandation1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        {dataForm.type_poste === 'PER' ? <>
                        </> : null}
                        <InputF  className="rounded-left mb-2" label="Lettre de recommendation 2"  type='file' name='recommandation2' onChange={(e) => handleFileChange(e,"recommandation2")} />
                        {!selectedFiles["recommandation2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            <InputF  required={true}  className="rounded-left mb-2" label="Résumé de la Thèse ou du Master" type='file' message={<span style={{color:'red'}}>*</span>} name='resume_these' onChange={(e) => handleFileChange(e,"resume_these")} />
                        {!selectedFiles["resume_these"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        <InputF className="rounded-left mb-2" label="Publications scientifiques"  type='file' name='publication_scientifique' onChange={(e) => handleFileChange(e,"publication_scientifique")} />
                        {!selectedFiles["publication_scientifique"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        {/* Gestion d'ajout de nouveau champs */}
                        <div className='autres_publications' >
                        {gestionfichier["publication_scientifique"] ?  
                                <>
                                {!InputVisible.publication2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication2' onChange={(e) => handleFileChange(e,"publication2")} />
                                        {!selectedFiles["publication2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {/* Fin de Gestion d'ajout de nouveau champs */}
                        {gestionfichier["publication2"] ?  
                                <>
                                {!InputVisible.publication3    ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication3' onChange={(e) => handleFileChange(e,"publication3")} />
                                        {!selectedFiles["publication3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {gestionfichier["publication3"] ?  
                                <>
                                {!InputVisible.publication4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication4' onChange={(e) => handleFileChange(e,"publication4")} />
                                        {!selectedFiles["publication4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {gestionfichier["publication4"] ?  
                            <>
                            {!InputVisible.publication5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication5' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication5' onChange={(e) => handleFileChange(e,"publication5")} />
                                    {!selectedFiles["publication5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication5"] ?  
                            <>
                            {!InputVisible.publication6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication6' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication6' onChange={(e) => handleFileChange(e,"publication6")} />
                                    {!selectedFiles["publication6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication6"] ?  
                            <>
                            {!InputVisible.publication7   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication7' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication7' onChange={(e) => handleFileChange(e,"publication7")} />
                                    {!selectedFiles["publication7"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication7"] ?  
                            <>
                            {!InputVisible.publication8   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication8' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication8' onChange={(e) => handleFileChange(e,"publication8")} />
                                    {!selectedFiles["publication8"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication8"] ?  
                            <>
                            {!InputVisible.publication9   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication9' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication9' onChange={(e) => handleFileChange(e,"publication9")} />
                                    {!selectedFiles["publication9"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {/* {gestionfichier["publication9"] ?  
                            <>
                            {!InputVisible.publication10   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication10' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication10' onChange={(e) => handleFileChange(e,"publication10")} />
                                    {!selectedFiles["publication10"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        } */}
                        </div>
                        <InputF  className="rounded-left mb-2" label="Communications"  type='file' name='communication' onChange={(e) => handleFileChange(e,"communication")} />
                        {!selectedFiles["communication"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            {gestionfichier["communication"]?  
                                <>
                                {!InputVisible.communication2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication2' onChange={(e) => handleFileChange(e,"communication2")} />
                                        {!selectedFiles["communication2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication2"] ?  
                                <>
                                {!InputVisible.communication3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication3' onChange={(e) => handleFileChange(e,"communication3")} />
                                        {!selectedFiles["communication3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication3"] ?  
                                <>
                                {!InputVisible.communication4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication4' onChange={(e) => handleFileChange(e,"communication4")} />
                                        {!selectedFiles["communication4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication4"] ?  
                                <>
                                {!InputVisible.communication5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication5' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication5' onChange={(e) => handleFileChange(e,"communication5")} />
                                        {!selectedFiles["communication5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    </>: null }
                    {/* <InputF className="rounded-left mb-2" label="Autres éléments de preuve pouvant justifier le CV" type='file' name='justificatif1' onChange={(e) => handleFileChange(e,"justificatif1")} />   */}
                    {!selectedFiles["justificatif1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    {/* {gestionfichier["justificatif1"] ?  
                                <>
                                {!InputVisible.justificatif2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif2' onChange={(e) => handleFileChange(e,"justificatif2")} />
                                        {!selectedFiles["justificatif2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {/* {gestionfichier["justificatif2"] ?  
                                <>
                                {!InputVisible.justificatif3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif3' onChange={(e) => handleFileChange(e,"justificatif3")} />
                                        {!selectedFiles["justificatif3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {/* {gestionfichier["justificatif3"] ?  
                                <>
                                {!InputVisible.justificatif4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif4' onChange={(e) => handleFileChange(e,"justificatif4")} />
                                        {!selectedFiles["justificatif4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {/* {gestionfichier["justificatif4"] ?  
                                <>
                                {!InputVisible.justificatif5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif5' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif5' onChange={(e) => handleFileChange(e,"justificatif5")} />
                                        {!selectedFiles["justificatif5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {/* {gestionfichier["justificatif5"] ?  
                                <>
                                {!InputVisible.justificatif6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif6' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif6' onChange={(e) => handleFileChange(e,"justificatif6")} />
                                        {!selectedFiles["justificatif6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {/* {gestionfichier["justificatif6"] ?  
                                <>
                                {!InputVisible.justificatif7   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif7' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif7' onChange={(e) => handleFileChange(e,"justificatif7")} />
                                        {!selectedFiles["justificatif7"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {/* {gestionfichier["justificatif7"] ?  
                                <>
                                {!InputVisible.justificatif8   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif8' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif8' onChange={(e) => handleFileChange(e,"justificatif8")} />
                                        {!selectedFiles["justificatif8"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    {complete}
                </div>
                )}
           </div>
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step < 3 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 3 && 
                <Button  variant="primary" type='submit' size="md"
                // disabled={!ok}
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
        </div>
        </div>
      </div>
    </>
  )
}
export default Depot